module.exports = __webpack_public_path__ + "static/media/document.a85bc0c2.svg";